// @ngInject
export function rebroadcastTaskModalCtrl($scope, $rootScope, $uibModalInstance, DatabaseApi, toaster, visitInstanceId) {
    $scope.visitInstanceId = visitInstanceId;

    $scope.broadcast = function() {
        $uibModalInstance.close({ success: true, didBroadcast: true });
    };

    $scope.dontBroadcast = function() {
        $uibModalInstance.close({ success: true, didBroadcast: false });
    };
} 